import { render, staticRenderFns } from "./ImportParts.vue?vue&type=template&id=4c715849"
import script from "./ImportParts.vue?vue&type=script&lang=js"
export * from "./ImportParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports